import InnerContent from "@/routes/components/InnerContent";
import PrivateRoute from "@/routes/components/PrivateRoute";
import { renderRoutes } from "@/routes/lib/renderRoutes";
import { getRoutesConfig, navigationItems } from "@config";
import { authInfoSelect } from "@entities/auth";
import { LoginPage } from "@pages";

import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";

export const MainRoutes = (): JSX.Element => {
  const { shop } = useSelector(authInfoSelect);
  const routesConfig = getRoutesConfig();
  const nav = navigationItems(shop?.role.acl);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <InnerContent />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        {renderRoutes(routesConfig, nav)}
      </Route>
      <Route path="/login" element={<LoginPage />} />
    </Routes>
  );
};

export default MainRoutes;
